import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { BeatLoader } from 'react-spinners';
import theme from '../utils/theme';

interface Option {
  slug: string;
  name: string;
}

interface AsyncSelectProps {
  selectedOption: Option | null;
  options: Option[];
  setSelectedOption: (option: Option | null) => void;
  placeholder: string;
  error?: string;
  setSearchText: (text: string) => void;
  loading: boolean;
}

const AsyncSelect: React.FC<AsyncSelectProps> = ({
  selectedOption,
  options,
  setSelectedOption,
  placeholder,
  error,
  setSearchText,
  loading,
}) => {
  return (
    <Autocomplete
      value={selectedOption}
      isOptionEqualToValue={(option, value) => option.slug === value.slug}
      onChange={(event, newValue) => {
        setSelectedOption(newValue);
      }}
      options={options}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          variant='standard'
          label={placeholder}
          onChange={(e) => setSearchText(e.target.value)}
          error={!!error}
          helperText={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <BeatLoader size={8} color={theme.palette.primary.main} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AsyncSelect;
